module.exports = __webpack_public_path__ + "img/xwqytitle.7d66c9bf.png";